// Levels the desk draws on a chart (a paper plan's entry, stop and targets): labelled price lines on
// the candles, replaced as a set.
import { LineStyle, type IPriceLine, type ISeriesApi } from 'lightweight-charts';
import { palette } from './palette';

export interface PlanMark { price: number; label: string; kind: 'entry' | 'stop' | 'target' | string }

export class PlanMarks {
  private lines: IPriceLine[] = [];
  private marks: PlanMark[] = [];
  constructor(private series: ISeriesApi<'Candlestick'>) {}
  set(marks: PlanMark[]) {
    this.marks = marks;
    for (const l of this.lines) this.series.removePriceLine(l);
    const C = palette();
    this.lines = marks.filter((m) => Number.isFinite(m.price) && m.price > 0).map((m) => this.series.createPriceLine({
      price: m.price, title: m.label, lineWidth: 2, axisLabelVisible: true,
      color: m.kind === 'stop' ? C.amber : m.kind === 'target' ? C.g : C.blue,
      lineStyle: m.kind === 'entry' ? LineStyle.Solid : LineStyle.LargeDashed,
    }));
  }
  /** Redraw in the current theme's colours. */
  repaint() { this.set(this.marks); }
}
